export default __webpack_public_path__ + "static/media/WCHSS_abstract-template.035f36e4.docx";